<div #mainDiv_ll_model_census_switch>


  <!-- horzTabs_ll_company_switch  TABS ACROSS THE TOP-->
  <div [hidden]="!bundle.showHorzTabs"
       [style.top.px]="bundle.horzTabsY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute;z-index:100">

    <canvas #horzTabs_ll_model_census_switch></canvas>

  </div>



  <!-- ll-contact-info-->
  <div *ngIf="bundle.showRemaining"
       [style.top.px]="bundle.remainingY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute; z-index: 100">

    <!--<ll-loanmgmt-loanrecord *ngIf="bundle.hTabIndx == 0" id="ll-loanmgmt-bbc-switch"></ll-loanmgmt-loanrecord>-->
    <!--<ll-loanmgmt-bbc *ngIf="bundle.hTabIndx == 1" id="bbc"></ll-loanmgmt-bbc>-->
    <!--<ll-loanmgmt-bbc *ngIf="bundle.hTabIndx == 2" id="payerClasses"></ll-loanmgmt-bbc>-->
    <!--<ll-admin-generic-dg *ngIf="bundle.hTabIndx == 2" id="model_reports_dg"></ll-admin-generic-dg>-->
    <!--<ll-loanmgmt-bbc *ngIf="bundle.hTabIndx == 3" id="locations"></ll-loanmgmt-bbc>-->
  </div>




</div>
